import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    innerItemContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    rightInfo: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    itemName: {
        color: '#FFFFFF'
    },
    favoritesItem: {
        color: Theme.labelTextColor
    }
};

export default StyleSheet.create(baseStyles);
